import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

const FilterChips = ({
  activeTab,
  searchValue,
  filters = {},
  onRemoveFilter,
  onClearAll,
  showClearAll = true,
  chipClassName = "",
  clearAllClassName = "",
}) => {
  const [showAllChips, setShowAllChips] = useState(false);
  const MAX_VISIBLE_CHIPS = 10;
  // Filter labels mapping
  const filterLabels = {
    searchTerm: "Search",
    selectedVolIss: "Vol/Iss",
    selectedArticleTypes: "Article Type",
    selectedCopyediting: "Copyediting",
    selectedDueDate: "Due Date",
    selectedJournals: "Journal",
  };

  const allActiveFilters = Object.entries(filters).filter(([key, value]) => {
    if (Array.isArray(value)) {
      return value.length > 0 && !(value.length === 1 && value[0] === "All");
    }
    if (typeof value === "string") {
      return value.trim() !== "";
    }
    return false;
  });

  // Get non-search filters to determine if we should show "Applied Filters"
  const nonSearchFilters = allActiveFilters.filter(
    ([key]) => key !== "searchTerm"
  );

  if (allActiveFilters.length === 0) return null;

  return (
    <div className="mb-2 text-sm text-gray-600">
      {/* Search term display - always show if exists */}

      {/* Only show filter chips section if we have non-search filters */}
      {nonSearchFilters.length > 0 && (
        <div className="flex items-center flex-wrap gap-2 mt-2">
          {/* Show "Applied Filters" label only when we have non-search filters */}
          <span className="text-[13px] leading-[16px] text-[#35424D]">
            Applied Filters:
          </span>

          {/* Render filter chips */}
          {(() => {
            // Create array of all chips
            const allChips = [];
            nonSearchFilters.forEach(([filterKey, filterValue]) => {
              if (Array.isArray(filterValue)) {
                filterValue
                  .filter((val) => val !== "All")
                  .forEach((value) => {
                    allChips.push(
                      <Chip
                        key={`${filterKey}-${value}`}
                        label={`${filterLabels[filterKey] || filterKey}: ${
                          value === "Alll"
                            ? "All"
                            : value === "coverHandler"
                            ? "Cover handler"
                            : value === "webHandler"
                            ? "Web handler"
                            : value === "tocHandler"
                            ? "TOC handler"
                            : value === "finalizingHandler"
                            ? "Finalizing handler"
                            : value
                        }`}
                        onRemove={() => onRemoveFilter(filterKey, value)}
                        className={chipClassName}
                      />
                    );
                  });
              }
              // ✅ Add this for single string values like "True"
              if (typeof filterValue === "string") {
                allChips.push(
                  <Chip
                    key={`${filterKey}-${filterValue}`}
                    label={`${
                      filterLabels[filterKey] || filterKey
                    }: ${filterValue}`}
                    onRemove={() => onRemoveFilter(filterKey, filterValue)}
                    className={chipClassName}
                  />
                );
              }
            });

            // Determine which chips to show
            const visibleChips = showAllChips
              ? allChips
              : allChips.slice(0, MAX_VISIBLE_CHIPS);
            const hasMoreChips = allChips.length > MAX_VISIBLE_CHIPS;

            return (
              <>
                {visibleChips}
                {hasMoreChips && (
                  <button
                    onClick={() => setShowAllChips(!showAllChips)}
                    className="text-[13px] leading-[16px] text-[#1C40C9] underline font-medium"
                  >
                    {showAllChips
                      ? `Show Less`
                      : `+${allChips.length - MAX_VISIBLE_CHIPS} More`}
                  </button>
                )}
              </>
            );
          })()}

          {/* Clear All button */}
          {showClearAll && (
            <button
              onClick={onClearAll}
              className={`text-[13px] leading-[16px] text-[#1C40C9] underline ${clearAllClassName}`}
            >
              Clear All
            </button>
          )}
        </div>
      )}
    </div>
  );
};

// Chip component remains unchanged
const Chip = ({ label, onRemove, className = "" }) => {
  const defaultClasses =
    "inline-flex items-center h-[28px] px-2 py-1 border border-[#1C40C9] text-[13px] leading-[18px] font-medium text-[#1C40C9] bg-[#E1E6FF] rounded-full";

  return (
    <span className={`${defaultClasses} ${className}`}>
      {label}
      <button onClick={onRemove} className="ml-2">
        <FaTimes className="text-[#1C40C9] w-[12px] h-[12px]" />
      </button>
    </span>
  );
};

export default FilterChips;
